/* Silvano — update OTIMISTA do minicart (igual ao Hydrogen useOptimisticCart).
   Ao mudar quantidade/remover: atualiza preço da linha, subtotal, contador e a
   bolinha do header NA HORA (sem tocar em imagens/estrutura) e persiste no
   /cart/change.js em background, reconciliando os valores exatos da resposta.
   Neutraliza o handler do Dawn (que substitui o innerHTML inteiro e causa o
   "pisca") interceptando os eventos na fase de captura e cortando a propagação.
   ponytail: reimplementa o update do carrinho só pro drawer; a página /cart
   segue no fluxo padrão do Dawn. */
(function () {
  'use strict';

  var CHANGE_URL =
    (window.routes && window.routes.cart_change_url) ? window.routes.cart_change_url : '/cart/change.js';

  /* ---- money format (Shopify.formatMoney canônico) ---- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10);
    if (isNaN(cents)) cents = 0;
    var re = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || '{{amount}}';
    function fwd(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cts = parts[1] ? decimal + parts[1] : '';
      return dollars + cts;
    }
    var m = fmt.match(re);
    var token = m ? m[1] : 'amount';
    var value;
    switch (token) {
      case 'amount': value = fwd(cents, 2); break;
      case 'amount_no_decimals': value = fwd(cents, 0); break;
      case 'amount_with_comma_separator': value = fwd(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fwd(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fwd(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = fwd(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = fwd(cents, 0, ' ', ''); break;
      case 'amount_with_period_and_space_separator': value = fwd(cents, 2, ' ', '.'); break;
      default: value = fwd(cents, 2);
    }
    return fmt.replace(re, value);
  }

  function root() { return document.querySelector('[data-sv-cd]'); }
  function fmt(cents) {
    var r = root();
    return formatMoney(cents, r ? r.getAttribute('data-money-format') : '');
  }

  /* ---- recalcula subtotal + contador a partir do DOM (otimista) ---- */
  function recompute() {
    var items = document.querySelectorAll('[data-sv-cd] .sv-cd__item');
    var subtotal = 0, count = 0;
    items.forEach(function (li) {
      var unit = parseInt(li.getAttribute('data-unit-price'), 10) || 0;
      var input = li.querySelector('.sv-cd__qty');
      var q = input ? (parseInt(input.value, 10) || 0) : 0;
      subtotal += unit * q;
      count += q;
      var priceNow = li.querySelector('.sv-cd__price-now');
      if (priceNow) priceNow.textContent = fmt(unit * q);
      var minus = li.querySelector('.sv-cd__step-btn[name="minus"]');
      if (minus) {
        var atMinimum = q <= (parseInt(input && input.min, 10) || 1);
        minus.disabled = atMinimum;
        minus.classList.toggle('disabled', atMinimum);
      }
      var plus = li.querySelector('.sv-cd__step-btn[name="plus"]');
      if (plus) {
        var atMaximum = input && input.max && q >= parseInt(input.max, 10);
        plus.disabled = atMaximum;
        plus.classList.toggle('disabled', atMaximum);
      }
    });
    var subEl = document.querySelector('[data-sv-cd] .sv-cd__subtotal-value');
    if (subEl) subEl.textContent = fmt(subtotal);
    var drawer = root();
    var discount = parseInt(drawer && drawer.getAttribute('data-cart-discount'), 10) || 0;
    var totalEl = document.querySelector('[data-sv-cd] .sv-cd__checkout-value');
    if (totalEl) totalEl.textContent = fmt(Math.max(0, subtotal - discount));
    var countEl = document.querySelector('[data-sv-cd] .sv-cd__count');
    if (countEl) countEl.textContent = count + ' ' + (count === 1 ? 'item' : 'itens');
    setBubble(count);
  }

  function setBubble(count) {
    var link = document.getElementById('cart-icon-bubble');
    if (!link) return;
    var wrap = link.querySelector('.sv-header__iconwrap') || link;
    var bubble = link.querySelector('.cart-count-bubble');
    if (count > 0) {
      if (!bubble) {
        bubble = document.createElement('span');
        bubble.className = 'cart-count-bubble';
        bubble.setAttribute('aria-hidden', 'true');
        wrap.appendChild(bubble);
      }
      bubble.textContent = count > 99 ? '99+' : count;
    } else if (bubble) {
      bubble.remove();
    }
  }

  /* ---- persistência (debounce por linha) + reconciliação ---- */
  var updates = {};
  function persist(key, qty) {
    var update = updates[key] || (updates[key] = { revision: 0, inFlight: false });
    update.quantity = qty;
    update.revision += 1;
    clearTimeout(update.timer);
    update.timer = setTimeout(function () { sendUpdate(key); }, 300);
  }

  function sendUpdate(key) {
    var update = updates[key];
    if (!update || update.inFlight) return;
    var revision = update.revision;
    var quantity = update.quantity;
    update.inFlight = true;

    fetch(CHANGE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (update.revision !== revision) return;
        delete updates[key];
        reconcile(cart);
      })
      .catch(function () {
        if (update.revision === revision) delete updates[key];
      })
      .finally(function () {
        update.inFlight = false;
        if (updates[key] === update && update.revision !== revision) sendUpdate(key);
      });
  }

  function reconcile(cart) {
    if (!cart || !cart.items) return;
    if (cart.item_count === 0) { renderEmpty(); setBubble(0); return; }
    var byKey = {};
    cart.items.forEach(function (it) { byKey[it.key] = it; });
    document.querySelectorAll('[data-sv-cd] .sv-cd__item').forEach(function (li) {
      var input = li.querySelector('.sv-cd__qty');
      var key = input && input.getAttribute('data-quantity-line-key');
      var it = key && byKey[key];
      if (!it) { li.remove(); return; }              // removido no servidor
      if (updates[key]) return;
      li.setAttribute('data-unit-price', it.final_price);
      if (input && parseInt(input.value, 10) !== it.quantity) input.value = it.quantity;
      var now = li.querySelector('.sv-cd__price-now');
      if (now) now.textContent = fmt(it.final_line_price);
    });
    var subEl = document.querySelector('[data-sv-cd] .sv-cd__subtotal-value');
    if (subEl) subEl.textContent = fmt(cart.items_subtotal_price);
    var drawer = root();
    if (drawer) drawer.setAttribute('data-cart-discount', cart.items_subtotal_price - cart.total_price);
    var countEl = document.querySelector('[data-sv-cd] .sv-cd__count');
    if (countEl) countEl.textContent = cart.item_count + ' ' + (cart.item_count === 1 ? 'item' : 'itens');
    setBubble(cart.item_count);
    recompute();
  }

  function renderEmpty() {
    fetch(location.pathname + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.drawer__inner');
        var cur = document.querySelector('#CartDrawer .drawer__inner');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        var dw = document.querySelector('cart-drawer');
        if (dw) dw.classList.add('is-empty');
      });
  }

  function keyOf(el) {
    var li = el.closest('.sv-cd__item');
    var input = li && li.querySelector('.sv-cd__qty');
    return input && input.getAttribute('data-quantity-line-key');
  }

  /* ---- captura: botões de quantidade (não deixa o Dawn disputar o estado) ---- */
  document.addEventListener('click', function (e) {
    var button = e.target.closest && e.target.closest('.sv-cd__step-btn');
    if (!button || !button.closest('[data-sv-cd]')) return;
    e.preventDefault();
    e.stopPropagation();

    var li = button.closest('.sv-cd__item');
    var input = li && li.querySelector('.sv-cd__qty');
    if (!input) return;

    var quantity = parseInt(input.value, 10) || 1;
    var step = parseInt(input.step, 10) || 1;
    var minimum = parseInt(input.min, 10) || 1;
    var maximum = input.max ? parseInt(input.max, 10) : null;
    var next = button.name === 'plus' ? quantity + step : quantity - step;
    next = Math.max(minimum, maximum === null ? next : Math.min(next, maximum));
    if (next === quantity) return;

    input.value = next;
    recompute();
    var key = input.getAttribute('data-quantity-line-key');
    if (key) persist(key, next);
  }, true);

  /* ---- captura: quantidade (bloqueia o Dawn) ---- */
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('.sv-cd__qty');
    if (!input || !input.closest('[data-sv-cd]')) return;
    e.stopPropagation(); // corta o handler do Dawn (re-render/flash)
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 1) { qty = 1; input.value = 1; }
    recompute();
    var key = input.getAttribute('data-quantity-line-key');
    if (key) persist(key, qty);
  }, true);

  /* ---- captura: remover ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.sv-cd__remove');
    if (!btn || !btn.closest('[data-sv-cd]')) return;
    e.stopPropagation();
    e.preventDefault();
    var key = keyOf(btn);
    var li = btn.closest('.sv-cd__item');
    if (li) li.remove();                 // remoção instantânea (otimista)
    if (!document.querySelector('[data-sv-cd] .sv-cd__item')) {
      setBubble(0);
      if (key) fetch(CHANGE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function () { renderEmpty(); });
      return;
    }
    recompute();
    if (key) persist(key, 0);
  }, true);
})();
